module.exports.parseSlug = (slug) => {
  if (!slug) {
    return '';
  }

  const lowercasedSlug = slug.toLowerCase();

  return lowercasedSlug.endsWith('/') ? lowercasedSlug : `${lowercasedSlug}/`
}
